// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
  width: 100%;
  max-width: 800px;
  margin: auto;
}

.accordion-item {
  border: 1px solid #ccc;
  margin: 10px 0;
  border-radius: 4px;
}

.accordion-label {
  display: block;
  padding: 10px;
  background: #f7f7f7;
  cursor: pointer;
  font-weight: bold;
}

.accordion-content {
  display: none;
  padding: 10px;
  background: #fff;
}

input[type="checkbox"]:checked + .accordion-label + .accordion-content {
  display: block;
}

.download-button,
.submit-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.instructions .step {
  margin-bottom: 15px;
}

.instructions pre {
  background: #f7f7f7;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

.instructions code {
  display: block;
}

.image-preview {
  margin-top: 10px;
}

.image-preview img {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}

.report-form {
  display: flex;
  flex-direction: column;
  max-width: 400px;
}

.report-form div {
  margin-bottom: 10px;
}

.report-form label {
  margin-bottom: 5px;
  font-weight: bold;
}

.report-form textarea,
.report-form input[type="file"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.report-form textarea {
  resize: vertical;
}

.report-form button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.ChoosenSettings {
  max-width: 400px;
}

.ChoosenSettings h3 {
  margin-bottom: 10px;
}

.ChoosenSettings label {
  display: block;
  margin-bottom: 8px;
}

.ChoosenSettings input[type="radio"] {
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/AdminRoot/Accordion.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".accordion {\n  width: 100%;\n  max-width: 800px;\n  margin: auto;\n}\n\n.accordion-item {\n  border: 1px solid #ccc;\n  margin: 10px 0;\n  border-radius: 4px;\n}\n\n.accordion-label {\n  display: block;\n  padding: 10px;\n  background: #f7f7f7;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.accordion-content {\n  display: none;\n  padding: 10px;\n  background: #fff;\n}\n\ninput[type=\"checkbox\"]:checked + .accordion-label + .accordion-content {\n  display: block;\n}\n\n.download-button,\n.submit-button {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.instructions .step {\n  margin-bottom: 15px;\n}\n\n.instructions pre {\n  background: #f7f7f7;\n  padding: 10px;\n  border-radius: 4px;\n  overflow-x: auto;\n}\n\n.instructions code {\n  display: block;\n}\n\n.image-preview {\n  margin-top: 10px;\n}\n\n.image-preview img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 4px;\n}\n\n.report-form {\n  display: flex;\n  flex-direction: column;\n  max-width: 400px;\n}\n\n.report-form div {\n  margin-bottom: 10px;\n}\n\n.report-form label {\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.report-form textarea,\n.report-form input[type=\"file\"] {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.report-form textarea {\n  resize: vertical;\n}\n\n.report-form button {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n.ChoosenSettings {\n  max-width: 400px;\n}\n\n.ChoosenSettings h3 {\n  margin-bottom: 10px;\n}\n\n.ChoosenSettings label {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.ChoosenSettings input[type=\"radio\"] {\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
